import KeyMirror from 'keymirror';

export default KeyMirror({
    UPDATE_ANSWERS: true,
    RESET_ANSWERS: true,
});
